// Material Kit 2 React pages
import Faculty from "pages/Faculty";

export default function FacultyMember() {
  return <Faculty />;
}
